import axios from "axios";
import { toast } from "react-toastify";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const Data = error?.response?.data;
    const errors = Object.values(Data?.errors);
    if (errors[0]?.length > 0) {
      errors[0]?.map((e) => toast.error(e));
    } else {
      if (Data) {
        toast.error(Data?.message);
      } else {
        toast.error(error?.message);
      }
    }
    return Promise.reject(error);
  }
);